import { BookReadingData } from '@lwtears/lwt-common-frontend/lib/types';
import { GET_READ_STORY_STUDENT, GET_READ_STORY_EDUCATOR } from '../../../graph/queries/readStory';
import { QueryResult, useQuery } from '@apollo/client';
import { BookParams } from '../../../types';
import { isStudentApp } from '../../../util/app-util';
import { Asset } from '../../../graph/schema-generated-types-educator';

const useReadStoryStore = (bookParams: BookParams): [BookReadingData] => {
  const query = isStudentApp ? GET_READ_STORY_STUDENT : GET_READ_STORY_EDUCATOR;
  const {
    data,
    loading,
    error,
  }: QueryResult<{ readStory: { book: any; pages: any[]; instructions: Asset } }> = useQuery(
    query,
    {
      variables: {
        readActivityWhere: {
          book: {
            bookCode: bookParams.bookCode,
            type: bookParams.bookType,
            edition: 2022,
            character: { character: bookParams.letter },
          },
        },
      },
    }
  );
  const { book = null, pages = null, instructions = null } = data?.readStory ?? {};

  return [
    {
      book,
      pages,
      instructions,
      error,
      loading,
    },
  ];
};

export default useReadStoryStore;
